import COLORS from "../../config/colors";

export default function MarkPaidModal({
  invoice, onClose, onConfirm, saving,
  paymentForm, setPaymentForm,
  styles,
}) {
  if (!invoice) return null;

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center" }} onClick={onClose}>
      <div onClick={e => e.stopPropagation()} style={{ background: COLORS.white, borderRadius: 16, padding: 32, width: 420, boxShadow: "0 12px 40px rgba(0,0,0,0.15)" }}>
        <h3 style={styles.sectionTitle}>Mark as Paid</h3>
        <p style={{ color: COLORS.stone, fontSize: 13, marginBottom: 16 }}>
          {invoice.invoice_number || invoice.id} — ${Number(invoice.total || invoice.amount || 0).toLocaleString()}
        </p>

        <div style={{ marginBottom: 16 }}>
          <label style={styles.label}>Payment Method</label>
          <div style={{ display: "flex", gap: 8 }}>
            {["check", "cash", "transfer", "stripe"].map(m => (
              <button key={m} onClick={() => setPaymentForm(f => ({ ...f, method: m }))} style={{ padding: "8px 14px", borderRadius: 8, border: `2px solid ${paymentForm.method === m ? COLORS.pine : "rgba(155,142,130,0.2)"}`, background: paymentForm.method === m ? "rgba(74,124,89,0.06)" : COLORS.white, color: COLORS.bark, fontSize: 12, fontWeight: 600, cursor: "pointer", fontFamily: "'DM Sans', sans-serif", textTransform: "capitalize" }}>
                {m}
              </button>
            ))}
          </div>
        </div>

        <div style={{ marginBottom: 20 }}>
          <label style={styles.label}>Payment Proof (optional)</label>
          <p style={{ fontSize: 12, color: COLORS.stone, marginBottom: 8 }}>Photo of check, screenshot of transfer, etc.</p>
          <input
            type="file" accept="image/*,.pdf"
            onChange={e => setPaymentForm(f => ({ ...f, proofFile: e.target.files[0] || null }))}
            style={{ fontSize: 13, fontFamily: "'DM Sans', sans-serif" }}
          />
          {paymentForm.proofFile && <div style={{ fontSize: 12, color: COLORS.pine, marginTop: 4 }}>{paymentForm.proofFile.name}</div>}
        </div>

        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={onClose} style={styles.secondaryBtn}>Cancel</button>
          <button onClick={() => onConfirm(invoice)} disabled={saving} style={{ ...styles.primaryBtn, flex: 1, background: COLORS.pine }}>
            {saving ? "Saving..." : "Confirm Payment"}
          </button>
        </div>
      </div>
    </div>
  );
}
